import { TableCell, TableRow } from "@/components/ui/table";
import type { ComponentNode } from "../utils/component-tree";

/**
 * Dòng tiêu đề nhóm theo hợp phần trong các bảng inline của lệnh (chế độ cây).
 * `node` = null → nhóm "Dùng chung cho cả lệnh".
 */
export function ComponentGroupRow({
  node,
  colSpan,
  count,
  unitLabel,
  productLabel,
}: {
  node: ComponentNode | null;
  colSpan: number;
  count?: number;
  unitLabel?: string;
  productLabel?: string;
}) {
  const depth = node?.depth ?? 0;
  return (
    <TableRow
      data-testid="po-component-group"
      data-component-id={node?.id || ""}
      data-depth={depth}
      className="bg-indigo-50/60 hover:bg-indigo-50/60 border-b border-indigo-100"
    >
      <TableCell colSpan={colSpan} className="py-1.5">
        <div className="flex items-center gap-2 text-xs" style={{ paddingLeft: depth * 16 }}>
          {depth > 0 && <span className="text-indigo-300 font-mono">└</span>}
          <span className="font-bold text-indigo-900">{node ? node.name : "Dùng chung cho cả lệnh"}</span>
          {node && depth > 0 && <span className="text-[11px] text-indigo-500 truncate">{node.path}</span>}
          {productLabel && <span className="text-[11px] text-slate-500 truncate">· {productLabel}</span>}
          {count !== undefined && (
            <span className="ml-auto text-[11px] text-slate-500 shrink-0">
              {count} {unitLabel || "dòng"}
            </span>
          )}
        </div>
      </TableCell>
    </TableRow>
  );
}
